function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Brick from "zengular/src/brick";
import { magic, MagicFormWrapperBrick } from "zengular-magic";
import TabData from "./tab-data";
import MagicFetch from "./magic-fetch";
/**
 * @property {string} name
 * @property {MagicFetch} fetch
 * @property {Brick} form
 * @property {{buttons: Array, limit: number, search: Brick|null, card: Brick, sort: {fields: Array, default: {field: string, order: string}}}} list
 */

var Handler = /*#__PURE__*/function () {
  /**
   *
   * @param {string} name
   * @param {string} api
   */
  function Handler(name) {
    _classCallCheck(this, Handler);

    this.name = name;
    this.fetcher = null;
    this.form = null;
    this.list = null;
  }
  /**
   * @returns {*}
   */


  _createClass(Handler, [{
    key: "fetch",
    get: function get() {
      if (typeof this._fetch === "undefined") this._fetch = new this.fetcher();
      return this._fetch;
    }
  }, {
    key: "selectItemEventData",
    value: function selectItemEventData() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new TabData({
        handler: this.name,
        id: id
      }, this.form, this.createId(id));
    }
  }, {
    key: "createId",
    value: function createId(id) {
      return 'handler-' + this.name + '-' + (id === null || id === '' ? 'new' : id);
    }
  }, {
    key: "translate",
    value: function translate(key) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!Array.isArray(key)) key = [key];
      key.unshift(this.name);
      key.unshift('handler');
      return magic.i18n.get(key, def);
    }
  }, {
    key: "dictionary",
    set: function set(data) {
      var dictionary = {
        handler: {}
      };
      dictionary['handler'][this.name] = data;
      magic.i18n.append(dictionary);
    }
  }]);

  return Handler;
}();

export { Handler as default };